import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxPermissionsModule } from 'ngx-permissions';
import { SharedModule } from '../../shared/shared.module';
import { AddEditCarrierMarketplaceMappingComponent } from './components/add-edit-carrier-marketplace-mapping/add-edit-carrier-marketplace-mapping.component';
import { AddEditCarrierComponent } from './components/add-edit-carrier/add-edit-carrier.component';
import { CarrierMarketplaceMappingsListingComponent } from './components/carrier-marketplace-mappings-listing/carrier-marketplace-mappings-listing.component';
import { CarriersListingComponent } from './components/carriers-listing/carriers-listing.component';
import { ShippingCarriersHomeComponent } from './components/shipping-carriers-home/shipping-carriers-home.component';
import { CustomTooltipDirective } from '../../shared/directives/custom-tooltip.directive';
import { CustomTooltipComponent } from '../../shared/features/layout/components/custom-tooltip/custom-tooltip.component';

@NgModule({
  declarations: [
    CarriersListingComponent,
    AddEditCarrierComponent,
    ShippingCarriersHomeComponent,
    CarrierMarketplaceMappingsListingComponent,
    AddEditCarrierMarketplaceMappingComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    SharedModule,
    CustomTooltipComponent,
    CustomTooltipDirective,
    NgxPermissionsModule.forChild(),
  ],
})
export class ShippingCarriersModule {}
  